import "./ArtTechnology.css";

import photoImg from "./assets/images/photo.png";
import paintingImg from "./assets/images/painting.png";

import cameraIcon from "./assets/images/camera-icon.png";
import paintingIcon from "./assets/images/painting-icon.png";

function ArtTechnologySection() {
  return (
    <section className="art-tech">

      <div className="cards-section">

        <a
          href="https://www.artoreal.com/photograph"
          target="_blank"
          rel="noopener noreferrer"
          className="card-link"
        >
          <div className="card">

            <img
              src={photoImg}
              alt="Photographs"
              className="card-image"
            />

            <div className="icon-circle">
              <img
                src={cameraIcon}
                alt="Camera"
                className="icon-image"
              />
            </div>

            <p>Photographs</p>

          </div>
        </a>

        <a
          href="https://www.artoreal.com/painting"
          target="_blank"
          rel="noopener noreferrer"
          className="card-link"
        >
          <div className="card">

            <img
              src={paintingImg}
              alt="Paintings"
              className="card-image"
            />

            <div className="icon-circle">
              <img
                src={paintingIcon}
                alt="Paintings"
                className="icon-image"
              />
            </div>

            <p>Paintings</p>

          </div>
        </a>

      </div>

      <div className="text-section">

        <h2>
          Where <span>ART</span> meets
          <br />
          <span>TECHNOLOGY</span>
        </h2>

        <div className="line"></div>

        <p>
          SAIT operates{" "}
          <a
            href="https://www.artoreal.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Artoreal,
          </a>{" "}
          a web-to-wall
          e-commerce site where customers and artists can
          register to buy and sell high quality photographs,
          digital art, paintings and art prints with a mission
          to Democratize Art for All, from art connoisseurs
          and high net-worth individuals to a wider target
          of home buyers and corporates.
        </p>

      </div>

    </section>
  );
}

export default ArtTechnologySection;